<template>
  <div class="rule-text-box" v-loading.fullscreen="isLoading">
    <div v-if="remoteContent" v-html="remoteContent"></div>
    <template v-else-if="lang === 'en-US'">
      <h2
        data-mce-style="text-align: center;"
        style="text-align: center;"
        align="center"
      >
        <strong
          ><span lang="EN-US"
            >Application for App Permissions and Instructions for Use</span
          ></strong
        ><span lang="EN-US"></span>
      </h2>
      <p>
        <span lang="EN-US"
          >1. &nbsp;&nbsp; We may apply for or use the relevant permissions of
          the operating system to for the realization and safe and stable
          operation of products or services;</span
        ><span lang="EN-US"></span>
      </p>
      <p>
        <span lang="EN-US"
          >2. &nbsp;&nbsp; In order to protect your right to know, we will
          display the relevant operating system permissions that may be applied
          for or used by our products or services in the following list, so that
          you can manage the relevant permissions according to your actual
          needs;</span
        ><span lang="EN-US"></span>
      </p>
      <p>
        <span lang="EN-US"
          >3. &nbsp;&nbsp; Since the types of permission applied for and use
          purposes may change with the upgrading of the products or services, we
          will adjust the list based on such changes in time to ensure that you
          are informed of the application and use of permission in a timely
          manner;</span
        ><span lang="EN-US"></span>
      </p>
      <p>
        <span lang="EN-US"
          >4. &nbsp;&nbsp; These instructions apply to CIFTIS APP, and the
          specific scope of application will be explained in the following
          list.</span
        ><span lang="EN-US"></span>
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p>
        <strong
          ><span lang="EN-US"
            >List of Permissions for Android APPs</span
          ></strong
        ><span lang="EN-US"></span>
      </p>
      <p>
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp; Webcam (camera)</span
        >
      </p>
      <p>
        <span lang="EN-US">Name of permission: android.permission.CAMERA</span>
      </p>
      <p>
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp; Permission to scan QR
          codes, etc.</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp; Scanning QR
          codes</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Contacts</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.READ_CONTACTS</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          contacts</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Social interaction</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p><span lang="EN-US">Type of permission: &nbsp;&nbsp; Tel</span></p>
      <p>
        <span lang="EN-US"
          >Name of permission: android.permission.CALL_PHONE</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp; Access to the calls</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp; Contact us
          by call</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p><span lang="EN-US">Type of permission: &nbsp;&nbsp; Location</span></p>
      <p>
        <span lang="EN-US"
          >Name of permission: android.permission.ACCESS_FINE_LOCATION</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp; Access to exact
          location</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp; Access to
          current geographic location</span
        >
      </p>
      <p><span lang="EN-US">Type of permission: &nbsp;&nbsp; File</span></p>
      <p>
        <span lang="EN-US"
          >Name of permission: android.permission.WRITE_EXTERNAL_STORAGE,</span
        >
      </p>
      <p><span lang="EN-US">android.permission.READ_EXTERNAL_STORAGE</span></p>
      <p>
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp; Reading or writing in the
          file</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp; Reading or
          storing cache data</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p><span lang="EN-US">Type of permission: &nbsp;&nbsp; Log</span></p>
      <p>
        <span lang="EN-US"
          >Name of permission: android.permission.READ_LOGS</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp; Reading system logs</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp; Uploading
          logs and analyzing crash logs, etc</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p><span lang="EN-US">Type of permission: &nbsp;&nbsp; Calendar</span></p>
      <p>
        <span lang="EN-US"
          >Name of permission: android.permission.READ_CALENDAR</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp; Access to system
          calendar</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp; Reading or
          writing in calendar information, scheduling conference</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p><span lang="EN-US">Type of permission: &nbsp;&nbsp; Location</span></p>
      <p>
        <span lang="EN-US"
          >Name of permission: android.permission.ACCESS_COARSE_LOCATION</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp; Access to fuzzy
          geographical location</span
        >
      </p>
      <p>
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp; Access to
          information around the current location</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Album</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.READ_APP_BADGE</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Uploading
          photo</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Uploading pictures during live streaming</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Phone state</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.READ_PHONE_STATE</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          phone state, such as 4G signal</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Providing content based on network state</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Microphone</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.RECORD_AUDIO</span
        ><span>，</span
        ><span lang="EN-US">android.permission.MODIFY_AUDIO_SETTINGS</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Recording,
          modifying recording settings in the system</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Enabling voice call function, modifying voice settings</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Network</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.ACCESS_NETWORK_STATE,</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">android.permission.ACCESS_WIFI_STATE,</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >android.permission.READ_PHONE_SINTERNETWIFI_STATE</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          network state</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Providing content based on network state</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Bluetooth</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.BLUETOOTH_ADMIN</span
        ><span>，</span><span lang="EN-US"></span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">android.permission.BLUETOOTH,</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">android.permission.BLUETOOTH_PRIVILEGED</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          Bluetooth permission</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Access to Bluetooth devices</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Vibrator</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp; android.permission.VIBRATE</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          vibrator permission</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Improving scanning recognition rate</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Apply</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.KILL_BACKGROUND_PROCESSES</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Allowing the
          app to shut down background processes</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Restarting the app</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Notification policy</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.ACCESS_NOTIFICATION_POLICY</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          notification policy</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Checking or modifying notification policy</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Keyguard</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.DISABLE_KEYGUARD</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Allowing the
          app to disable keyguard</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Neglecting the keyguard</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Boot</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.RECEIVE_BOOT_COMPLETED</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to boot
          event</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Performing related operations when the mobile phone is turned on</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Broadcast</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.BROADCAST_STICKY</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          sticky broadcast</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Access to the last broadcast event when re-registering a broadcast
          event</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Network</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp; android.permission.INTERNET</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          network permission</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Access to the network</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Overlay window</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.SYSTEM_OVERLAY_WINDOW,</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">android.permission.SYSTEM_ALERT_WINDOW</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          overlay window permission</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A
          dialog box pops up</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Window</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.USE_FULL_SCREEN_INTENT</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to
          full-screen application permission</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Hiding the phone status bar</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Installing app</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.REQUEST_INSTALL_PACKAGES</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to app
          installation permission</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Permission to install app(s) for higher versions</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Modifying settings</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          android.permission.WRITE_SETTINGS</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Permission to
          modify system settings</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Modifying system settings</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Performing tasks</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp; android.permission.GET_TASKS</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Access to the
          permission to perform tasks</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The
          app performs tasks</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Time</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp; android.permission.SET_TIME</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Modifying
          system time</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Modifying system time</span
        >
      </p>
      <p><span lang="EN-US">&nbsp;</span></p>
      <p>
        <strong
          ><span lang="EN-US">List of Permissions for IOS APPs</span></strong
        ><span lang="EN-US"></span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Location</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 10pt;"
        data-mce-style="margin-left: 10pt;"
      >
        <span lang="EN-US"
          >Name of permission:
          NSLocationAlwaysUsageDescription;NSLocationWhenInUseUsageDescription</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Need to obtain
          your location to provide more precise service</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Access to your location</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Webcam (camera)</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp; NSCameraUsageDescription</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Permission to
          scan QR codes and live stream</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Scanning QR codes, live streaming</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Album</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp; NSPhotoLibraryUsageDescription
          (access to album); NSPhotoLibraryAddUsageDescription (save picture to
          album)</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Permission to
          upload photos, videos, etc.</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Uploading pictures during live streaming</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">Type of permission: &nbsp;&nbsp;&nbsp; Contact</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp; NSContactsUsageDescription</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Enable cloud
          conference to query call list</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Access to Contact</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Bluetooth</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          NSBluetoothPeripheralUsageDescription</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Calling
          Bluetooth function, realizing device connection and matching</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Enabling Bluetooth</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US">&nbsp;</span>
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Type of permission: &nbsp;&nbsp;&nbsp; Bluetooth</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Name of permission: &nbsp;&nbsp;
          NSBluetoothAlwaysUsageDescription</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Function of permission: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Calling
          Bluetooth function, realizing device connection and matching</span
        >
      </p>
      <p
        class="ql-line"
        style="margin-left: 0cm;"
        data-mce-style="margin-left: 0cm;"
      >
        <span lang="EN-US"
          >Application scenario or purpose: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Enabling Bluetooth</span
        >
      </p>
      <p></p>
    </template>
    <template v-else>
      <h2 align="center"><strong>应用权限申请与使用情况说明</strong></h2>
      <p>
        1、为保障产品或服务能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；
      </p>
      <p>
        2、为保障您的知情权，我们通过下列列表将产品或服务可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；
      </p>
      <p>
        3、根据产品或服务的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况；
      </p>
      <p>4、本说明适用于服贸会APP，具体的适用范围将在以下列表中说明。</p>
      <p>&nbsp;</p>
      <p><strong>安卓操作系统应用权限列表</strong></p>
      <p>权限类型：摄像头（相机）</p>
      <p>权限名称：<strong>android.permission.CAMERA</strong></p>
      <p>权限功能说明：该权限用于扫描二维码等功能</p>
      <p>使用场景或目的：扫描二维码</p>
      <p>&nbsp;</p>
      <p class="ql-line">权限类型：通讯录</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.READ_CONTACTS</strong>
      </p>
      <p class="ql-line">权限功能说明：获取通信录信息</p>
      <p class="ql-line">使用场景或目的：社会互动</p>
      <p>&nbsp;</p>
      <p>权限类型：电话</p>
      <p>权限名称：<strong>android.permission.CALL_PHONE</strong></p>
      <p>权限功能说明：获取打电话的功能</p>
      <p>使用场景或目的：联系我们，拨打电话</p>
      <p>&nbsp;</p>
      <p>权限类型：位置</p>
      <p>权限名称：<strong>android.permission.ACCESS_FINE_LOCATION</strong></p>
      <p>权限功能说明：获取精确位置</p>
      <p>使用场景或目的：获取当前地理位置</p>
      <p>权限类型：文件</p>
      <p>
        权限名称：<strong
          >android.permission.WRITE_EXTERNAL_STORAGE，android.permission.READ_EXTERNAL_STORAGE</strong
        >
      </p>
      <p>权限功能说明：读取或写入文件</p>
      <p>使用场景或目的：读取或存储缓存数据</p>
      <p>&nbsp;</p>
      <p>权限类型：日志</p>
      <p>权限名称：<strong>android.permission.READ_LOGS</strong></p>
      <p>权限功能说明：读取系统日志</p>
      <p>使用场景或目的：日志上传，分析崩溃日志等</p>
      <p>&nbsp;</p>
      <p>权限类型：日历</p>
      <p>权限名称：<strong>android.permission.READ_CALENDAR</strong></p>
      <p>权限功能说明：获取系统日历信息</p>
      <p>使用场景或目的：读取或写入日历信息，预约会议</p>
      <p>&nbsp;</p>
      <p>权限类型：位置</p>
      <p>
        权限名称：<strong>android.permission.ACCESS_COARSE_LOCATION</strong>
      </p>
      <p>权限功能说明：获取模糊地理位置</p>
      <p>使用场景或目的：获取当前位置周围信息</p>
      <p>&nbsp;</p>
      <p class="ql-line">权限类型：相册</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.READ_APP_BADGE</strong>
      </p>
      <p class="ql-line">权限功能说明：上传照片</p>
      <p class="ql-line">使用场景或目的：直播上传图片</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：手机状态</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.READ_PHONE_STATE</strong>
      </p>
      <p class="ql-line">权限功能说明：获取收集状态，如 4G 信号</p>
      <p class="ql-line">使用场景或目的：根据网络状态提供内容</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：麦克风</p>
      <p class="ql-line">
        权限名称：<strong
          >android.permission.RECORD_AUDIO，android.permission.MODIFY_AUDIO_SETTINGS</strong
        >
      </p>
      <p class="ql-line">权限功能说明：录音，修改系统录音设置</p>
      <p class="ql-line">使用场景或目的：提供语音通话功能，修改语音设置</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：网络</p>
      <p class="ql-line">
        权限名称：<strong
          >android.permission.ACCESS_NETWORK_STATE，android.permission.ACCESS_WIFI_STATE，android.permission.READ_PHONE_SINTERNETWIFI_STATE</strong
        >
      </p>
      <p class="ql-line">权限功能说明：获取网络状态</p>
      <p class="ql-line">使用场景或目的：根据网络状态，提供内容</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：蓝牙</p>
      <p class="ql-line">
        权限名称：<strong
          >android.permission.BLUETOOTH_ADMIN，android.permission.BLUETOOTH,android.permission.BLUETOOTH_PRIVILEGED</strong
        >
      </p>
      <p class="ql-line">权限功能说明：获取蓝牙权限</p>
      <p class="ql-line">使用场景或目的：接入蓝牙设备</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：振动器</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.VIBRATE</strong>
      </p>
      <p class="ql-line">权限功能说明：获取振动器权限</p>
      <p class="ql-line">使用场景或目的：提高扫码识别率</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：应用</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.KILL_BACKGROUND_PROCESSES</strong>
      </p>
      <p class="ql-line">权限功能说明：允许关闭后台进程</p>
      <p class="ql-line">使用场景或目的：重启应用</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：通知策略</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.ACCESS_NOTIFICATION_POLICY</strong>
      </p>
      <p class="ql-line">权限功能说明：访问通知策略</p>
      <p class="ql-line">使用场景或目的：查看或修改通知策略</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：键盘锁</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.DISABLE_KEYGUARD</strong>
      </p>
      <p class="ql-line">权限功能说明：允许禁用键盘锁</p>
      <p class="ql-line">使用场景或目的：忽略键盘锁</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：开机启动</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.RECEIVE_BOOT_COMPLETED</strong>
      </p>
      <p class="ql-line">权限功能说明：获取开机启动事件</p>
      <p class="ql-line">使用场景或目的：手机开机时执行相关操作</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：广播</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.BROADCAST_STICKY</strong>
      </p>
      <p class="ql-line">权限功能说明：获取粘性广播</p>
      <p class="ql-line">
        使用场景或目的：再注册广播事件时，获取最后发出的广播事件
      </p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：网络</p>
      <p class="ql-line">权限名称：android.permission.INTERNET</p>
      <p class="ql-line">权限功能说明：获取网络权限</p>
      <p class="ql-line">使用场景或目的：访问网络</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：悬浮窗</p>
      <p class="ql-line">
        权限名称：<strong
          >android.permission.SYSTEM_OVERLAY_WINDOW，android.permission.SYSTEM_ALERT_WINDOW</strong
        >
      </p>
      <p class="ql-line">权限功能说明：获取悬浮窗权限</p>
      <p class="ql-line">使用场景或目的：弹出对话框</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：窗口</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.USE_FULL_SCREEN_INTENT</strong>
      </p>
      <p class="ql-line">权限功能说明：获取全屏应用权限</p>
      <p class="ql-line">使用场景或目的：隐藏手机状态条</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：安装应用</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.REQUEST_INSTALL_PACKAGES</strong>
      </p>
      <p class="ql-line">权限功能说明：获取安装应用权限</p>
      <p class="ql-line">使用场景或目的：用于高版本安装应用的权限</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：修改设置</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.WRITE_SETTINGS</strong>
      </p>
      <p class="ql-line">权限功能说明：修改系统设置权限</p>
      <p class="ql-line">使用场景或目的：用于修改系统设置</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：执行任务</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.GET_TASKS</strong>
      </p>
      <p class="ql-line">权限功能说明：获取执行任务权限</p>
      <p class="ql-line">使用场景或目的：用于应用执行任务</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：时间</p>
      <p class="ql-line">
        权限名称：<strong>android.permission.SET_TIME</strong>
      </p>
      <p class="ql-line">权限功能说明：修改系统时间</p>
      <p class="ql-line">使用场景或目的：修改系统时间</p>
      <p>&nbsp;</p>
      <p class="ql-line">权限类型：访问WiFi及网络接口</p>
      <p class="ql-line">
        权限名称：<strong
          >android.permission.ACCESS_WIFI_STATE，android.permission.INTERNET</strong
        >
      </p>
      <p class="ql-line">
        权限功能说明：用于访问WiFi获取状态信息，并遍历各个网络接口获取Mac地址
      </p>
      <p class="ql-line">使用场景或目的：将Mac地址作为手机设备的唯一标识</p>
      <p>&nbsp;</p>
      <p><strong>IOS</strong><strong>操作系统应用权限列表</strong></p>
      <p class="ql-line">权限类型：位置</p>
      <p class="ql-line">
        权限名称：<strong
          >NSLocationAlwaysUsageDescription;NSLocationWhenInUseUsageDescription</strong
        >
      </p>
      <p class="ql-line">
        权限功能说明：需要获取您的位置信息，以提供更精准的服务
      </p>
      <p class="ql-line">使用场景或目的：获取您的位置</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：摄像头（相机）</p>
      <p class="ql-line">权限名称：NSCameraUsageDescription</p>
      <p class="ql-line">权限功能说明：该权限将被用于拍摄二维码、直播</p>
      <p class="ql-line">使用场景或目的：扫码、直播</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：相册</p>
      <p class="ql-line">
        权限名称：<strong
          >NSPhotoLibraryUsageDescription（获取相册图片）；NSPhotoLibraryAddUsageDescription（图片保存到相册）</strong
        >
      </p>
      <p class="ql-line">权限功能说明：该权限将被用于照片、视频上传等功能</p>
      <p class="ql-line">使用场景或目的：直播上传图片</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：联系人</p>
      <p class="ql-line">
        权限名称：<strong>NSContactsUsageDescription</strong>
      </p>
      <p class="ql-line">权限功能说明：实现云会议查询通话列表功能</p>
      <p class="ql-line">使用场景或目的： 获取联系人</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：蓝牙</p>
      <p class="ql-line">
        权限名称：<strong>NSBluetoothPeripheralUsageDescription</strong>
      </p>
      <p class="ql-line">权限功能说明：调用蓝牙功能、实现设备连接、匹配</p>
      <p class="ql-line">使用场景或目的：启用蓝牙</p>
      <p class="ql-line">&nbsp;</p>
      <p class="ql-line">权限类型：蓝牙</p>
      <p class="ql-line">
        权限名称：<strong>NSBluetoothAlwaysUsageDescription</strong>
      </p>
      <p class="ql-line">权限功能说明：调用蓝牙功能、实现设备连接、匹配</p>
      <p class="ql-line">使用场景或目的：启用蓝牙</p>
      <p class="ql-line">&nbsp;</p>
      <p></p>
    </template>
  </div>
</template>

<script>
import { getPolicyDetailById } from '@/api/newscenter-api'
import { getLang } from '@/utils'

export default {
  data() {
    return {
      locale: this.$route.query.lang == 'en' ? 'en-US' : '',
      lang: 'zh-CN',
      remoteContent: '',
      isLoading: true
    }
  },
  created() {
    const detectedLang = this.locale ? this.locale : getLang()
    if (detectedLang) {
      this.lang = detectedLang
    }
    this.loadContent()
  },
  methods: {
    async loadContent() {
      const {
        VUE_APP_APP_PERMISSION_ID = '',
        VUE_APP_APP_PERMISSION_EN_ID = ''
      } = process.env

      const targetId =
        this.lang === 'en-US'
          ? VUE_APP_APP_PERMISSION_EN_ID || VUE_APP_APP_PERMISSION_ID
          : VUE_APP_APP_PERMISSION_ID

      if (!targetId) {
        this.isLoading = false
        return
      }

      this.isLoading = true
      try {
        const response = await getPolicyDetailById(targetId, this.lang)
        const richText = this.extractRichText(response)
        if (richText && richText.trim().length > 0) {
          this.remoteContent = richText
        }
      } catch (error) {
        // Fallback to bundled content on failure.
      } finally {
        this.isLoading = false
      }
    },
    extractRichText(response) {
      const result = response && response.result
      if (!result) {
        return ''
      }

      const container = result.content || result.data
      if (container && container.richText) {
        return container.richText.replace(
          /text-wrap-mode:\s*nowrap/g,
          'text-wrap-mode: wrap'
        )
      }

      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep table {
  border-collapse: collapse;
}
.rule-text-box {
  max-width: 1200px;
  width: 100%;
  margin: 20px auto;
  padding: 30px;
  background: #fff;
  font-size: 14px;
  line-height: 28px;
  overflow-x: auto;
  overflow-wrap: break-word;
  word-break: break-word;
  -webkit-overflow-scrolling: touch;
  h2 {
    margin: 0 0 32px;
    padding: 0 0 20px;
    border-bottom: 1px solid #eee;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  hr {
    margin: 20px 0;
  }
  a {
    color: #0175d4;
    text-decoration: underline;
  }
  table {
    width: 100%;
    margin: 12px 0;
    border-collapse: collapse;
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  th,
  td {
    padding: 6px 4px;
    border: 1px solid #ccc;
    background: #fff;
    white-space: normal;
    word-break: break-word;
  }
  th {
    background: #f5f5f5;
  }
  img {
    max-width: 100%;
    height: auto;
  }
}
@media screen and (max-width: 800px) {
  .rule-text-box {
    width: 100%;
    margin: 0;
    padding: 15px;
    line-height: 28px;
    h2 {
      margin: 6px 0 10px;
      padding: 0;
      border-bottom: none;
      font-size: 20px;
      line-height: 36px;
    }
  }
}
</style>
